import { memo } from "react";
import { Image } from "expo-image";
import { StyleSheet } from "react-native-unistyles";

type VideoThumbnailOverlayProps = {
  thumbnailUrl: string;
};

export const VideoThumbnailOverlay = memo(({ thumbnailUrl }: VideoThumbnailOverlayProps) => {
  // "contain" (not "cover") so the whole thumbnail is visible and matches the
  // video's contentFit="contain" — with "cover" the thumbnail was cropped at
  // the edges, cutting off the dump the reviewer is scanning for. The black
  // background fills any letterbox bars so the box still reads as full.
  return <Image source={{ uri: thumbnailUrl }} style={styles.thumbnailImage} contentFit="contain" />;
});

const styles = StyleSheet.create((theme) => ({
  thumbnailImage: {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 1,
    borderRadius: theme.spacing.md,
    backgroundColor: "#000",
  },
}));
